<template>
  <svg width="27px" height="24px" viewBox="0 0 27 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="10-Hinweisgebertool" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="10.2_-Hinweistool_notification" transform="translate(-47.000000, -397.000000)" fill="currentColor">
            <g id="Hinweisstool" transform="translate(30.000000, 379.000000)">
                <path d="M28.1288212,18 L38.622571,35.9846224 L41.7168924,35.9846224 L44,39.7935901 L22.5351454,39.7935901 L21.2218934,42 L17,42 L27.3027376,23.9885834 L25.96355,21.5784347 L28.1288212,18 Z M29.5260313,27.6632448 L24.6811402,36.0796537 L34.5604969,36.0796537 L29.5260313,27.6632448 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'Hint'
};
</script>
